import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const navigate = useNavigate();
  const [status, setStatus] = useState("polling");
  const [tx, setTx] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/checkout/status/${sessionId}`);
        setTx(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
      } catch {}
      attempts++;
      if (attempts >= 15) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8">
      <div className="surface-card p-10 max-w-lg w-full text-center">
        {status === "polling" && (
          <>
            <Loader2 className="size-12 mx-auto mb-4 gold-text animate-spin" strokeWidth={1.4}/>
            <h2 className="font-display text-2xl font-semibold mb-2">Επιβεβαίωση πληρωμής…</h2>
            <p className="text-muted-foreground text-[13px]">Παρακαλώ περιμένετε.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="size-14 mx-auto mb-4 text-emerald-400" strokeWidth={1.4}/>
            <h2 className="font-display text-3xl font-semibold mb-2">Επιτυχής πληρωμή</h2>
            <p className="text-muted-foreground text-[13.5px] mb-2">{tx?.metadata?.label || ""}</p>
            <p className="text-muted-foreground text-[12.5px] mb-6 font-mono">€{tx?.amount} {tx?.currency?.toUpperCase()}</p>
            <button data-testid="payment-continue-btn" onClick={() => navigate("/billing")}
              className="px-5 py-2.5 rounded-md bg-[hsl(var(--gold))] text-[hsl(var(--background))] font-medium text-[13px]">
              Συνέχεια
            </button>
          </>
        )}
        {(status === "failed" || status === "timeout" || status === "error") && (
          <>
            <XCircle className="size-14 mx-auto mb-4 text-red-400" strokeWidth={1.4}/>
            <h2 className="font-display text-2xl font-semibold mb-2">{status === "timeout" ? "Καθυστέρηση επιβεβαίωσης" : "Αποτυχία πληρωμής"}</h2>
            <p className="text-muted-foreground text-[13px] mb-6">
              {status === "timeout"
                ? "Η πληρωμή ενδέχεται να καθυστερήσει. Ελέγξτε το πλάνο σας σε λίγο."
                : "Η συναλλαγή δεν ολοκληρώθηκε."}
            </p>
            <button onClick={() => navigate("/billing")}
              className="px-5 py-2.5 rounded-md border border-border/80 text-[13px]">
              Επιστροφή
            </button>
          </>
        )}
      </div>
    </div>
  );
}
